module.exports = __webpack_public_path__ + "images/img-2RghvUV.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/final.jpg
// module id = 2010
// module chunks = 0